export default __webpack_public_path__ + "static/media/optionsMore.3d601669.svg";